<app-header></app-header>
<div class="contenedor_principal">
  <app-menu-alterno></app-menu-alterno>
  <div class="contenidoDivTitulo">
    <div class="seccion-filtro-titulo">

      <div class="div-cuadro-busqueda">
        <input #myInput type="text" id="myInput" class="input-text" (keyup.enter)="filtrar(myInput.value)"
          placeholder="Buscar" title="Escriba una palabra clave"><input class="input-button" type="image"
          src="/estadisticas-economicas/assets/img/iconos/search.png" (click)="filtrar(myInput.value)" />
      </div>

      <div class="div-titulo-seccion">
        <h1 class="h1-titulo-app" [innerHTML]="constante.ETIQUETA_BOTON_TABLA_GRAFICO_PRECONSTRUIDO"></h1>
      </div>

    </div>

    <div class="div-linea-titulo"></div>
  </div>

  <app-menu-mas-consultados></app-menu-mas-consultados>

  <br>
  <!--div class="div-problema-tecnico escritorio-problema-tecnico">
    <span>Estamos experimentando inconvenientes técnicos de forma esporádica en 'Tablas preconstruidas' al momento de exportar a Excel o al visualizar datos. Si usted presenta inconvenientes, le invitamos a acceder temporalmente al siguiente <a target="_blank"
        href="https://totoro.banrep.gov.co/analytics/saw.dll?Portal&PortalPath=%2Fshared%2FDashboards_T%2FD_Estad%C3%ADsticas%2FEstad%C3%ADsticas&NQUser=publico&NQPassword=publico123&options=rdf>."
        class="enlace-problema-tecnico">enlace.</a></span>
  </div>

  <div class="div-problema-tecnico celular-problema-tecnico">
    <span>Estamos experimentando inconvenientes técnicos de forma esporádica en 'Tablas preconstruidas' al momento de visualizar datos. Si usted presenta inconvenientes, le invitamos a acceder temporalmente al siguiente <a target="_blank"
        href="https://totoro.banrep.gov.co/analytics/saw.dll?Portal&PortalPath=%2Fshared%2FDashboards_T%2FD_Estad%C3%ADsticas%2FEstad%C3%ADsticas&NQUser=publico&NQPassword=publico123&options=rdf>."
        class="enlace-problema-tecnico">enlace.</a></span>
  </div-->
  @if (cargandoInfo) {
  <img class="img-load-info" src="/estadisticas-economicas/assets/img/cargando_info.gif" alt="ícono cargando" title="cargando">
  }
  <div id="accordion" class="opcion-menu-accordion ui-accordion ui-widget ui-helper-reset" role="tablist">
    <cdk-accordion class="accordion-container">
      <cdk-accordion-item *ngFor="let dato of listaTablaCatalogo; let index=index;" #accordionItem="cdkAccordionItem"
        role="button" tabindex="0" [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <div class="accordion-item-header {{accordionItem.expanded ? 'is-active' : 'not-active'}}"
          (click)="accordionItem.toggle(); cambiarSeccion(dato.titulo)">
          <div class="div-titulo-dashboard">
            <img class="img-titulo-opcion" src="{{dato.imagen}}" alt="ícono título" title="título">
          </div>
          <div class="div-titulo-dashboard">
            <h2 class="h2-titulo">{{ dato.titulo }}</h2>
            <p class="p-titulo">{{dato.descripcion}}</p>
          </div>
          <div class="div-chart-mini">
            @if (dato.tieneChart) {
            <highcharts-chart [id]="'chart-seccion-' + index" class="highcharts-chart-mini"
              [Highcharts]="dato.highcharts" [options]="dato.chartOptions" [update]="false">
            </highcharts-chart>
            }
            <!--div [id]="dato.idChart" class="highcharts-chart-mini"></div-->
            <mat-icon *ngIf="!accordionItem.expanded" class="mat-icon-add">add</mat-icon>
            <mat-icon *ngIf="accordionItem.expanded" class="mat-icon-remove">remove</mat-icon>
          </div>
          <div>

          </div>
        </div>

        <div role="region" [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index">
          <div class="div-seccion-tab">

            <div class="contenidoDivTitulo">
              <h2 class="h2-titulo-app">Tablas preconstruidas</h2>
            </div>

            <div class="div-contenido-arbol">
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                  <a class="link-enlace-dashboard" (click)="abrirEnlace(node, dato.titulo)" [innerHTML]="node.nombre">
                    <mat-icon class="done-icon">done</mat-icon> </a>
                  <span *ngIf="node.url == ''">{{node.nombre}}</span>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <div class="mat-tree-node" [ngClass]="{'resaltado': nodoPadreEncontrado.includes(node)}">
                    <a mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.nombre">
                      <mat-icon class="mat-icon-rtl-mirror {{node.estilo}}">
                        {{treeControl.isExpanded(node) ? 'do_not_disturb_on' : 'add_circle'}}
                      </mat-icon>
                      <span class="span-mombre-opcion" [innerHTML]="node.nombre"></span>
                      <img *ngIf="nodoPadreEncontrado.includes(node)" style="margin-left: 25px;"
                        src="/estadisticas-economicas/assets/img/flecha_izquierda.png" width="25px" alt="ícono flecha" title="flecha izquierda">
                    </a>
                  </div>
                  <!-- There is inline padding applied to this div using styles.
                                              This padding value depends on the mat-icon-button width.  -->
                  <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>
            </div>
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>
  </div>
</div>